import { useEffect, useState } from "react";
import { deleteEmployeeForGood, getDeletePreview } from "../../services/employeeMergeApi";

/**
 * «Удалить насовсем» (Чат 4, правка №15, доработка 5 — Света 04.11): только владелец платформы,
 * для остальных — увольнение. Можно удалить и действующего, и уволенного. Для защиты от
 * случайного клика нужно ввести ФИО полностью. [Claude] 2026-11-04
 */
export default function EmployeeDeleteDialog({ employee, onClose, onDeleted }) {
    const [links, setLinks] = useState(null);
    const [name, setName] = useState("");
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        let alive = true;
        Promise.resolve().then(() => getDeletePreview(employee.id))
            .then((data) => { if (alive) setLinks(data?.links || []); })
            .catch((e) => { if (alive) { setLinks([]); setError(e.message || null); } });
        return () => { alive = false; };
    }, [employee.id]);

    const matches = name.trim().replace(/\s+/g, " ").toLocaleLowerCase("ru") === String(employee.full_name || "").trim().replace(/\s+/g, " ").toLocaleLowerCase("ru");

    const submit = async () => {
        setBusy(true);
        setError(null);
        try {
            await deleteEmployeeForGood(employee.id, name.trim());
            onDeleted?.();
        } catch (e) {
            setError(e.message || "Не удалось удалить");
        } finally {
            setBusy(false);
        }
    };

    return <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-slate-900/40 p-4" role="dialog" aria-modal="true" data-testid="employee-delete-dialog">
        <div className="w-full max-w-lg rounded-2xl bg-white p-5 shadow-xl">
            <h2 className="text-xl font-bold text-red-700">Удалить насовсем</h2>
            <p className="mt-2 text-sm text-slate-600">Карточка «{employee.full_name}» удалится без возможности восстановления. Если человек просто ушёл — оформите увольнение.</p>
            <p className="mt-2 text-sm text-slate-600">Вместе с ней: {links === null ? "считаем…" : (links.map((l) => l.label + ": " + l.count).join(", ") || "связанных данных нет")}. История передачи техники останется.</p>
            {employee.erp_user_id ? <p className="mt-2 rounded-lg bg-amber-50 px-3 py-2 text-sm text-amber-800">У сотрудника есть учётка ERP — в самой ERP она не удаляется.</p> : null}
            <label className="mt-4 block text-sm font-semibold text-slate-700">Для подтверждения введите ФИО полностью
                <input value={name} onChange={(e) => setName(e.target.value)} placeholder={employee.full_name} className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 font-normal" data-testid="delete-confirm-name" />
            </label>
            {error ? <p className="mt-2 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700" role="alert">{error}</p> : null}
            <div className="mt-4 flex justify-end gap-2">
                <button type="button" onClick={onClose} className="rounded-lg px-4 py-2 text-sm font-semibold text-slate-500 hover:text-slate-800">Отмена</button>
                <button type="button" disabled={!matches || busy} onClick={submit} className="rounded-lg bg-red-600 px-4 py-2 text-sm font-bold text-white hover:bg-red-500 disabled:opacity-40" data-testid="delete-submit">{busy ? "Удаляем…" : "Удалить насовсем"}</button>
            </div>
        </div>
    </div>;
}
